<app-header></app-header>
<app-navbar></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links" [subItems]="subLinks"></app-sidebar>
    </aside>
    <!-- <div class="ps-5">
        <h1>Catálogo de tasas administrativas</h1>
    </div> -->
    <main class="ps-5 w-100">
        <!-- Boton Nuevo -->
        <div class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">{{'catalog.title0' |
                    translate}}</h2>
                <button type="button" class="btn custombutton" (click)="newModel()">{{'buttons.newRegister' |
                    translate}}</button>
            </div>
        </div>
        <!-- Tabla de catálogo de tasas administrativass -->
        <div class="row CLASSNAME">
            <fieldset>
                <table id="table1" class="table" [attr.aria-label]="'catalog.title0' | translate">
                    <thead>
                        <tr>
                            <th scope="col">
                                <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ 'catalog.code' | translate }}</th>
                            <th scope="col">{{ 'catalog.description' | translate }}</th>
                            <th scope="col">{{ 'catalog.type' | translate }}</th>
                            <th scope="col">{{ 'catalog.activity' | translate }}</th>
                            <th scope="col">{{ 'catalog.descrServei' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of administrativeFeeCatalogResponse.listAdministrativeFeeCatalogDto"
                            [ngClass]="{ 'resaltado': selectedRowId === row.idAdministrativeFeesCatalog }">
                            <td>
                                <input [ariaLabel]="row.idAdministrativeFeesCatalog" type="radio" name="checkbox"
                                    title="select" [checked]="selectedRowId === row.idAdministrativeFeesCatalog"
                                    (click)="toggleRow(row)" />
                                <label [for]="'radio-' + row.idAdministrativeFeesCatalog" class="visually-hidden">
                                    {{ 'seleccionarFilaCon' | translate }}:
                                    {{ 'catalog.code' | translate }} {{ row.codeAdministrativeFeeCatalog }},
                                    {{ 'catalog.description' | translate }} {{
                                    row.administrativeFeeCatalogTraductionDto?.[0]?.description || 'N/A' }},
                                    {{ 'catalog.type' | translate }} {{ ('serviceType.' + (row.typology || '')) |
                                    translate
                                    }},
                                    {{ 'catalog.activity' | translate }} {{ row.serviceDto?.codeService || 'N/A' }},
                                    {{ 'catalog.descrServei' | translate }}

                                </label>
                            </td>
                            <td [attr.aria-label]="row.codeAdministrativeFeeCatalog">{{ row.codeAdministrativeFeeCatalog
                                }}
                            </td>
                            <td [attr.aria-label]="row.administrativeFeeCatalogTraductionDto?.[0]?.description">
                                {{ row.administrativeFeeCatalogTraductionDto?.[0]?.description }}
                            </td>
                            <td [attr.aria-label]="('serviceType.' + (row.typology || '')) | translate">
                                {{ ('serviceType.' + (row.typology || '')) | translate }}
                            </td>
                            <td [attr.aria-label]="row.serviceDto?.codeService">{{ row.serviceDto?.codeService }}</td>
                            <td>
                                <ng-container *ngFor="let serv of row.serviceDto?.serviceTraductionDto">
                                    <span *ngIf="serv.languageDto?.code === currentLanguage"
                                        [attr.aria-label]="serv.shortDescription">
                                        {{ serv.shortDescription }}
                                    </span>
                                </ng-container>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

        </div>
        <!-- Controles de paginación -->
        <div class="mt-2" *ngIf="this.administrativeFeeCatalogResponse.pageDto">
            <app-paginator [isStart]="this.administrativeFeeCatalogResponse.pageDto.start"
                [isEnd]="this.administrativeFeeCatalogResponse.pageDto.end"
                [currentPage]="this.administrativeFeeCatalogResponse.pageDto.currentPage"
                [totalPages]="this.administrativeFeeCatalogResponse.pageDto.pages"
                [numberRecord]="this.administrativeFeeCatalogResponse.pageDto.records"
                [sizePage]="this.administrativeFeeCatalogResponse.pageDto.pageSize">
            </app-paginator>
        </div>


        <!-- Formulario de Servicio trámite administrativo -->
        <div class="row NUEVO">
            <!-- ANGULAR -->
            <div *ngIf="selectedRowId || isCreate">
                <div>
                    <div class="separator mt-5"></div>
                    <h2 class="mb-3 mt-4 textformat">{{'catalog.serviceAdminTramit' |
                        translate}}</h2>
                </div>
                <form [formGroup]="administrativeCatalogForm">
                    <div class="row">
                        <div class="col-6 mb-3">
                            <label for="code">{{'catalog.code' |
                                translate}} <span>
                                    *</span></label>
                            <input id="code" name="code" type="text" class="form-control" placeholder="Número de código"
                                formControlName="code" />
                        </div>
                        <div class="col-6 mb-3">
                            <label for="typology">{{'catalog.type' | translate}}<span>
                                    *</span></label>
                            <select id="typology" name="typology" class="form-select" aria-label="typology"
                                formControlName="typology">
                                <option value=""></option>
                                <option value="O">{{'serviceType.O' | translate}}</option>
                                <option value="P">{{'serviceType.P' | translate}}</option>
                            </select>

                        </div>
                        <div class="col-6 mb-3">
                            <label for="active">{{ 'model.status' | translate}}<span>
                                    *</span></label>
                            <select class="form-select" id="active" name="active" formControlName="active">
                                <option value="S">{{ 'model.active' | translate }}</option>
                                <option value="N">{{ 'model.inactive' | translate }}</option>
                            </select>
                        </div>
                        <div class="col-6 mb-3">
                            <label for="activity">{{'catalog.activity' |translate}}<span>
                                    *</span></label>
                            <select id="activity" name="activity" class="form-select" aria-label="activity"
                                formControlName="activity">
                                <option value=""></option>
                                <option *ngFor="let service of this.listServices" [value]="service.idService">
                                    {{ service.codeService }} - {{service.serviceTraductionDto[0].shortDescription}}
                                </option>
                            </select>
                        </div>
                        <div class="col-6 mb-3">
                            <label for="descriptionCat">{{'catalog.catDescription' |
                                translate}}<span>
                                    *</span></label>
                            <input id="descriptionCat" name="descriptionCat" type="text" class="form-control"
                                placeholder="Ingrese la descripción en catalán" formControlName="descriptionCat" />
                        </div>
                        <div class="col-6 mb-3">
                            <label for="descriptionIng">{{'catalog.engDescription' |translate}}<span>
                                    *</span></label>
                            <input id="descriptionIng" name="descriptionIng" class="form-control"
                                placeholder="Ingrese la descripción en inglés" formControlName="descriptionIng" />
                        </div>

                        <div class="col-6 mb-3">
                            <label for="descriptionCast">{{'catalog.castDescription' |translate}}<span>
                                    *</span></label>
                            <input id="descriptionCast" name="descriptionCast" type="text" class="form-control"
                                placeholder="Ingrese la descripción en castellano" formControlName="descriptionCast" />
                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-between">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="registrationCancellationFee"
                                name="registrationCancellationFee"
                                (change)="toggleCheckbox('registrationCancellationFee')"
                                formControlName="registrationCancellationFee" />
                            <label class="form-check-label"
                                for="registrationCancellationFee">{{'catalog.registrationCancellationFee'
                                |
                                translate}}</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="registrationModificationFee"
                                name="registrationModificationFee" formControlName="registrationModificationFee"
                                (change)="toggleCheckbox('registrationModificationFee')" />
                            <label class="form-check-label"
                                for="registrationModificationFee">{{'catalog.registrationModificationFee'
                                |
                                translate}}</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="splitPaymentRate"
                                name="splitPaymentRate" formControlName="splitPaymentRate"
                                (change)="toggleCheckbox('splitPaymentRate')" />
                            <label class="form-check-label" for="splitPaymentRate">{{'catalog.splitPaymentRate' |
                                translate}}</label>
                        </div>

                    </div>
                    <div class="row d-flex">
                        <div class="col-12 mt-4">
                            <button type="button" class="btn cancelbutton me-2" (click)="onCancel()">Cancelar</button>
                            <button type="button" class="btn custombutton"
                                (click)="saveAdministrativeCatalog()">{{isCreate ? ('buttons.save' |
                                translate) : ('buttons.modify' | translate)}}</button>
                        </div>
                    </div>

                </form>
            </div>
            <app-alert-component [isDanger]="isError" [isOk]="isCreated" [message]="errorMessage"
                (close)="this.isCreated = this.isError = false"></app-alert-component>
        </div>

    </main>
</div>